import toDate from '../toDate/index.js'

/**
 * @name isWeekend
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Options} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Boolean} the date falls on a weekend
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * var result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */
export default function isWeekend (dirtyDate, dirtyOptions) {
  var date = toDate(dirtyDate, dirtyOptions)
  var day = date.getDay()
  return day === 0 || day === 6
}



//////////////////
// WEBPACK FOOTER
// ../~/date-fns/esm/isWeekend/index.js
// module id = 939
// module chunks = 0